import { Title } from '../../services/mypageService';
import './TitlesSection.css';

interface TitlesSectionProps {
  titles: Title[];
  selectedTitleId: number | null;
  onSelectTitle: (titleId: number) => void;
}

export const TitlesSection = ({
  titles,
  selectedTitleId,
  onSelectTitle,
}: TitlesSectionProps) => {
  const getRarityColor = (rarity: string) => {
    switch (rarity) {
      case 'legendary':
        return '#ff6b00';
      case 'epic':
        return '#9d4edd';
      case 'rare':
        return '#4cc9f0';
      case 'common':
        return '#6b7280';
      default:
        return '#6b7280';
    }
  };

  // 획득 조건 텍스트 생성
  const getRequirementText = (requirements: Title['requirements']): string => {
    if (!requirements || Object.keys(requirements).length === 0) {
      return '';
    }

    const conditions: string[] = [];
    
    if (requirements.gameCount) {
      conditions.push(`${requirements.gameCount}게임 완료`);
    }
    if (requirements.maxBalance) {
      const balanceInMillion = requirements.maxBalance / 1000000;
      conditions.push(`잔고 ${balanceInMillion}만원 달성`);
    }
    if (requirements.firstProfit) {
      conditions.push('첫 수익 달성');
    }
    if (requirements.winStreak) {
      conditions.push(`${requirements.winStreak}연승 달성`);
    }
    if (requirements.bestRank) {
      conditions.push(`랭킹 ${requirements.bestRank}위 안에 들기`);
    }
    if (requirements.minProfitRate !== undefined) {
      conditions.push(`손실율 ${requirements.minProfitRate}% 달성`);
    }
    if (requirements.singleGameProfitRate) {
      conditions.push(`한 게임에서 ${requirements.singleGameProfitRate}% 수익 달성`);
    }
    if (requirements.winRate) {
      conditions.push(`승률 ${requirements.winRate}% 이상 달성`);
    }
    if (requirements.recoveryFromLoss) {
      conditions.push('손실 후 복귀');
    }

    return conditions.join(', ');
  };

  return (
    <div className="titles-grid">
      {titles.map((title) => {
        const isSelected = title.titleId === selectedTitleId;
        const isUnlocked = title.isUnlocked;
        const requirementText = getRequirementText(title.requirements);

        return (
          <div
            key={title.titleId}
            className={`title-item ${isSelected ? 'selected' : ''} ${!isUnlocked ? 'locked' : ''}`}
            style={{
              borderColor: isSelected
                ? getRarityColor(title.rarity)
                : 'transparent',
              opacity: isUnlocked ? 1 : 0.5,
              cursor: isUnlocked ? 'pointer' : 'not-allowed',
            }}
            onClick={() => {
              if (isUnlocked) {
                onSelectTitle(title.titleId);
              }
            }}
            title={!isUnlocked ? `획득 조건: ${requirementText || title.description}` : undefined}
          >
            <div className="title-icon" style={{ opacity: isUnlocked ? 1 : 0.6 }}>
              {title.icon || '👑'}
            </div>
            <div className="title-info">
              <div className="title-name">{title.name}</div>
              <div className="title-description">
                {isUnlocked ? title.description : requirementText || title.description}
              </div>
              {!isUnlocked && requirementText && (
                <div className="title-requirement" style={{ 
                  fontSize: '0.75rem', 
                  color: 'var(--text-secondary)',
                  marginTop: '0.25rem',
                  fontStyle: 'italic'
                }}>
                  조건: {requirementText}
                </div>
              )}
              <div className="title-rarity" style={{ color: getRarityColor(title.rarity) }}>
                {title.rarity.toUpperCase()}
              </div>
            </div>
            {isSelected && isUnlocked && <div className="title-selected-badge">선택됨</div>}
            {!isUnlocked && <div className="title-locked-badge">🔒</div>}
          </div>
        );
      })}
    </div>
  );
};








